<template>
  <div :id="id + '_warp'" class="form_ui">
    <div class="display_flex">
      <div class="form_title" v-show="title">{{ title }}</div>
      <div class="form_btn align_center" v-if="isBtnShow">
        <span
          v-if="isFormCompileBtn"
          class="align_center form_btn_span"
          @click="handleCompile"
          @mouseenter="btn_index = 0"
          @mouseleave="btn_index = -1"
        >
          <img src="./img/compile_blue.svg" v-show="btn_index == 0" alt />
          <img src="./img/compile.svg" v-show="btn_index != 0" alt />
          编辑
        </span>
        <span
          v-if="!isFormCompileBtn"
          class="align_center form_btn_span"
          @click="handleSave"
          @mouseenter="btn_index = 1"
          @mouseleave="btn_index = -1"
        >
          <img src="./img/save_blue.svg" v-show="btn_index == 1" alt />
          <img src="./img/save.svg" v-show="btn_index != 1" alt />
          保存
        </span>
        <span
          v-if="!isFormCompileBtn"
          class="align_center form_btn_span"
          @click="handleCompile"
          @mouseenter="btn_index = 2"
          @mouseleave="btn_index = -1"
        >
          <img src="./img/beak_blue.svg" v-show="btn_index == 2" alt />
          <img src="./img/beak.svg" v-show="btn_index != 2" alt />
          取消
        </span>
        <!-- 头部信息插入按钮 -->
        <div>
          <slot name="header_btn"></slot>
        </div>
      </div>
    </div>
    <a-form-model :id="id" ref="form" :layout="'inline'">
      <!-- 过滤器使ishowNode可控制隐藏显示，不影响正常使用 -->
      <a-form-model-item
        v-for="(item, index) in getList"
        :key="index"
        :label="item.lable"
        :prop="item.name"
        :style="{ width: item.row == 2 ? '100%' : '50%' }"
      >
        <!-- ishowNode 是否显示 -->
        <template v-if="isCompile && item.ishowNode">
          <!-- 评分 -->
          <a-rate 
            v-if="item.type == 'rate'" 
            :value=Number(item.value)  
            :disabled="item.disabled" 
          />

          <!-- 图片 -->
          <div  v-if="item.type == 'imgList'">
              <img
                v-if="item.value != null"
                style="height: 50px;max-width: 100%;  margin-right: 4px"
                :src="url + item.value"
                @click="handleImg(item.value)"
              />
          </div>

          <a-input
            :disabled="item.disabled"
            v-if="item.type == 'input'"
            placeholder
            v-model="item.value"
            @change="changeAll"
          />

          <a-input-number
            :disabled="item.disabled"
            v-if="item.type == 'input_number'"
            placeholder="请输入"
            :formatter="inputNumberF"
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            v-model="item.value"
            @change="changeAll"
          />

          <a-input-password
            v-if="item.type == 'password'"
            placeholder="请输入密码"
            v-model="item.value"
            @change="changeAll"
          />

          <!-- 带图标的输入框 -->
          <div class="inputIcon" v-if="item.type == 'inputIcon'">
            <a-input
              :disabled="item.disabled"
              @change="changeAll"
              style="flex: 1"
              v-model="item.value"
            >
              <!-- <a-icon :component="item.svg" /> -->
            </a-input>
            <span class="icons" v-html="item.svg"></span>
          </div>

          <a-radio-group
            v-if="item.type == 'radio'"
            v-model="item.value"
            :disabled="item.disabled"
            :options="item.options"
            @change="changeAll"
          ></a-radio-group>

          <a-checkbox-group
            :disabled="item.disabled"
            v-if="item.type == 'checkbox'"
            v-model="item.value"
            :options="item.options"
            @change="changeAll"
          />

          <a-date-picker
            :disabled="item.disabled"
            v-if="item.type == 'date_picker'"
            v-model="item.value"
            format="YYYY-MM-DD"
            @change="changeAll"
          />

          <a-range-picker
            :disabled="item.disabled"
            v-if="item.type == 'range_picker'"
            v-model="item.value"
            format="YYYY-MM-DD"
            @change="changeAll"
          />

          <!-- selectSearch可搜索 -->
          <a-select
            style="width:100%"
            v-if="item.type == 'selectSearch'"
            v-model="item.value"
            :allowClear="true"
            :disabled="item.disabled"
            @search="ChangeSelectSearch($event, item)"
            @change="ChangeSelectSearch($event, item)"
            show-search
            :filter-option="filterOption"
            :not-found-content="null"
          >
            <!-- <a-icon slot="suffixIcon" type="search" /> -->
            <a-select-option
              v-for="(obj, i) in item.options"
              :key="i"
              :value="obj.value"
            >{{ obj.label }}</a-select-option>
          </a-select>

          <a-select
            v-if="item.type == 'select'"
            v-model="item.value"
            :disabled="item.disabled"
            @change="changeAll"
          >
            <a-select-option
              v-for="(obj, i) in item.options"
              :key="i"
              :value="obj.value"
            >{{ obj.label }}</a-select-option>
          </a-select>

          <!-- select标签选择器 -->
          <a-select
            v-if="item.type == 'selectTag'"
            mode="tags"
            v-model="item.value"
            :disabled="item.disabled"
            @change="changeAll"
          >
            <a-select-option
              v-for="(obj, i) in item.options"
              :key="i"
              :value="obj.value"
            >{{ obj.label }}</a-select-option>
          </a-select>

          <!-- 省市区联动 -->
          <div class="flex" v-if="item.type == 'selectProvince'">
            <a-select v-model="item.value" :disabled="item.disabled" @change="changeAll">
              <a-select-option
                v-for="(obj, i) in item.options"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
            <a-select
              style="margin-left: 20px"
              v-model="item.TwoValue"
              :disabled="item.disabled"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.optionsChild"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
            <a-select
              style="margin-left: 20px"
              v-model="item.ThreeValue"
              :disabled="item.disabled"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.optionsChilden"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
          </div>

          <!-- 市县联动 -->
          <div class="flex" v-if="item.type == 'selectCity'">
            <a-select
              allow-clear
              style="margin-left: 20px"
              v-model="item.TwoValue"
              :disabled="item.disabled"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.optionsChild"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
            <a-select
              allow-clear
              style="margin-left: 20px"
              v-model="item.ThreeValue"
              :disabled="item.disabled"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.optionsChilden"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
          </div>

          <!-- 自定义组件 -->
          <div class="flex" v-if="item.type == 'slotForm'">
            <a-input
              :disabled="item.disabled"
              placeholder
              v-model="item.value"
              @change="changeAll"
            />
            <a-button
              style="margin: auto 10px; color: #33b1eb; border-color: #33b1eb"
              size="small"
              @click="handleClickBtn(item)"
            >{{ item.btn_lable }}</a-button>
          </div>
          <div class="flex" v-if="item.type == 'selectSlot'">
            <a-select
              :disabled="item.disabled"
              placeholder
              v-model="item.value"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.options"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
            <a-button
              style="margin: auto 10px; color: #33b1eb; border-color: #33b1eb"
              size="small"
              @click="handleClickBtn(item)"
            >{{ item.btn_lable }}</a-button>
          </div>

          <div class="flex" v-if="item.type == 'TwoBtnSelect'">
            <a-select
              :disabled="item.disabled"
              placeholder
              v-model="item.value"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.options"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
            <a-button
              style="margin: auto 10px; color: #33b1eb; border-color: #33b1eb"
              size="small"
              @click="handleClickBtn(item)"
            >{{ item.btn_lable }}</a-button>
            <a-button
              style="margin: auto 5px; color: #33b1eb; border-color: #33b1eb"
              size="small"
              @click="handleClickBtn(item, 1)"
            >{{ item.btn_later }}</a-button>
          </div>

          <div class="flex" v-if="item.type == 'checkboxSlot'">
            <a-checkbox-group
              style="margin-top: 5px"
              :disabled="item.disabled"
              v-model="item.value"
              :options="item.options"
              @change="changeAll"
            />
            <a-button
              style="margin-left: 10px"
              type="primary"
              @click="handleClickBtn(item)"
            >{{ item.btn_lable }}</a-button>
          </div>

          <div class="flex" v-if="item.type == 'textarea'">
            <a-textarea :rows="4" v-model="item.value" @change="changeAll" />
          </div>

          <!-- 输入框+下拉框 -->
          <div class="flex" v-if="item.type == 'select_iput'">
            <a-input
              :disabled="item.disabled"
              placeholder
              v-model="item.value"
              @change="changeAll"
            />
            <a-select
              style="width: 190px; margin-left: 20px"
              :disabled="item.disabled"
              placeholder
              v-model="item.optVal"
              @change="changeAll"
            >
              <a-select-option
                v-for="(obj, i) in item.options"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
          </div>

          <!-- 范围 -->
          <div class="flex inpt_box" v-if="item.type == 'scope_iput'">
            <a-input
              :disabled="item.disabled"
              v-model="item.value"
              placeholder
              @change="ChangeNumber(item.value, index)"
            />一
            <a-input
              :disabled="item.disabled"
              placeholder
              v-model="item.laterVal"
              @change="ChangeNumberlater(item.laterVal, index)"
            />
            <span class="inpt_box_unit">%</span>
          </div>

          <!-- 模糊搜索下拉框+输入框 -->
          <div class="flex" v-if="item.type == 'serch_input'">
            <a-select
              style="flex: 1.8"
              v-model="item.value"
              :allowClear="true"
              :disabled="item.disabled"
              placeholder="请选择"
              @search="ChangeSelectSearch($event, item)"
              @change="ChangeSelectSearch($event, item)"
              show-search
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
            >
              <a-icon slot="suffixIcon" type="search" />
              <a-select-option
                v-for="(obj, i) in item.options"
                :key="i"
                :value="obj.value"
              >{{ obj.label }}</a-select-option>
            </a-select>
            <a-input
              style="margin-left: 10px; flex: 1"
              :disabled="item.disabled"
              placeholder
              v-model="item.laterVal"
              @change="changeAll"
            />
          </div>

          <!-- 带图标的输入框 -->
          <div class="flex align_center" v-if="item.type == 'redemption'">
            <div class="inputIcon" style="flex: 1">
              <a-input @change="changeAll" style="flex: 1"></a-input>
              <span class="icons" v-html="item.svg"></span>
            </div>
            <a-button
              style="margin: 0 10px"
              type="primary"
              size="small"
              ghost
              @click="handleClickBtn(item)"
            >{{ item.btn_name }}</a-button>
            <div>{{ item.text }}</div>
          </div>
        </template>
        <div v-else-if="item.type == 'rate'" >
          <a-rate 
            :value=Number(item.value)  
            :disabled="item.disabled" 
          />
        </div>
        <div v-else-if="item.type == 'imgList'" style="display: flex;">
            <!-- <img
              v-if="item.value != null"
              style="width: 50px; height: 50px; margin-right: 4px"
              :src="url + item.value"
              alt=""
            /> -->
            <div class="box" v-for="(itemOne, index) in item.value" :key="index" >
              <div class="mydiv">
                <img :src="url + itemOne" alt="" @click="handleImg(itemOne)" style="cursor: pointer"/>
              </div>
            </div>
        </div>
        <div v-else-if="item.type == 'selectTagSlot'" style="display: flex;">
          <!-- 多标签 + 按钮 -->
          <div class="flex" v-if="item.type == 'selectTagSlot'" style="flex: 1;flex-wrap: wrap;">
              <!-- 编辑 -->
              <div v-for="(itemOne, index) in item.value" v-if="!item.disabled">
                <a-tag closable @close="tagClose(itemOne)" @close.prevent>{{ itemOne.labelName }}</a-tag>
              </div>
              <!-- 查看 -->
              <div v-for="(itemOne, index) in item.value" v-if="item.disabled">
                <a-tag>{{ itemOne.labelName }}</a-tag>
              </div>
              <div style="flex: 1;"></div>
            <div>
              <a-button
                type="primary"
                @click="handleClickBtn(item)"
                v-if="!item.disabled"
              >{{ item.btn_lable }}</a-button>
             </div>
          </div>
        </div>
        <div v-else-if="item.ishowNode && !item.SlotName">
          <div v-if="item.options && item.options.length">
            <!-- 处理多选 -->
            <span v-for="(obj, index) in item.options" :key="index">
              <span v-if="item.type == 'selectTag'">
                <span v-show="item.value.split(',').indexOf(obj.value)>-1">{{ obj.label }}</span>
              </span>
              <span v-else-if="obj.value == item.value">{{ obj.label }}</span>
            </span>
          </div>
          <div v-else>{{ item.value }}</div>
        </div>
        <!-- 自定义插槽 -->
        <div v-else-if="item.ishowNode && item.SlotName">
          <slot :name="item.SlotName"></slot>
        </div>
      </a-form-model-item>
    </a-form-model>

    <!-- 表单 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancelImg"
      class="imgBox"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import mergeRegion from "./js/city.js";
export default {
  name: "FormInput",
  props: {
    title: {
      type: String,
      default: () => {
        return "";
      }
    },
    // 数据
    Formlist: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 是否编辑
    isCompile: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    // 是否显示编辑保存按钮
    isBtnShow: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    // 单独显示编辑按钮
    isFormCompileBtn: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    // 宽度
    label_width: {
      type: String,
      default: () => "100px"
    },
    // 表单验证
    rules: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: () => "form"
    }
  },
  watch: {
    Formlist: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.model = {};
        this.$nextTick(() => {
          let num = 0;
          newVal.map((item, i) => {
            num += item.row;
            this.model[item.name] = item.value;
          });
          this.FormFiels = newVal;
          this.isadd = false;
          this.handleMap();
        });
      }
    }
  },
  data() {
    return {
      btn_index: -1,
      model: {},
      isadd: true,
      FormFiels: [],
      selectVal: "",

      //图片
      url: process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      previewVisible: false,
      previewImage: "",
    };
  },
  computed: {
    // 过滤器处理if和for混用情况
    getList() {
      return this.Formlist.filter(item => {
        return item.ishowNode;
      });
    }
  },
  mounted() {},
  methods: {
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.previewImage = this.url + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    // 表单验证
    validate() {
      let pass;
      this.$refs.form.validate(valid => {
        pass = valid;
      });
      return pass;
    },
    // 编辑 & 取消
    handleCompile() {
      this.$emit("handleParentCompile");
    },
    // 保存
    handleSave() {
      this.$emit("handleParentSave");
    },
    // 监听数据
    handleMap() {
      let num = 0;
      this.$nextTick(() => {
        let list_div = document.getElementById(this.id).children;
        this.getList.map((item, i) => {
          // 设置效验
          Object.keys(this.rules).map(key => {
            if (item.name == key) {
              item.required = true;
              list_div[
                i
              ].children[0].innerHTML = `<span style="color:red;">*</span>${item.lable}`;
            }
          });
          // 设置效验
          if (item.required) {
            list_div[
              i
            ].children[0].innerHTML = `<span style="color:red;">*</span>${item.lable}`;
          } else {
            list_div[i].children[0].innerHTML = `${item.lable || ""}`;
          }
          // s色值labeel宽度
          if (list_div[i]) {
            list_div[i].children[0].style.width = this.label_width;
            if (list_div[i].children[1]) {
              list_div[
                i
              ].children[1].style.width = `calc(100% - ${this.label_width})`; // 处理超出
            }
          }
          // 处理边框线
          if (item.ishowNode && list_div[i]) {
            num += item.row;
            console.log(list_div[i], "list_div[i]")
            list_div[i].style.margin = 0
            if (num % 2 != 0) {
              list_div[i].style.borderLeft = "1px solid #e4e4e4";
              if (i != this.Formlist.length - 1) {
                list_div[i].style.borderLeft = "1px solid #e4e4e4";
              }
            } else if (num % 2 == 0 && item.row != 2) {
              list_div[i].style.borderLeft = "none";
            }
          }
        });
        if (this.Formlist[0].row == 2 && list_div[1]) {
          list_div[1].style.borderTop = "none";
        }
      });
    },
    // 监听事件
    changeAll() {
      this.$emit("formChangeAll", this.Formlist);
    },
    // 搜索单独处理
    ChangeSelectSearch(value, item) {
      if (value) {
        item.value = value;
      }
      // item.options = [
      //   { label: "定州", value: "11" },
      //   { label: "子位", value: "Pear" },
      //   { label: "李青顾", value: "Orange" }
      // ];
      this.changeAll();
    },
    // 弹框点击事件
    handleClickBtn(item, index) {
      let i = index ? index : 0;
      item.btn_idx = i;
      this.$emit("handleClickBtn", item);
    },
    //标签关闭时间
    tagClose(item) {
      this.$emit("tagClose", item);
    },
    // 数组框处理
    inputNumberF(value) {
      let num = 0;
      if (value) {
        let i = value.indexOf(".");
        if (i > 0) {
          num = value.slice(0, i);
          return (
            num.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
            value.slice(i, value.length)
          );
        } else {
          value = value + ".00";
        }
      } else {
        return value;
      }
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 范围输入框设置只能输入数字
    ChangeNumber(value, index) {
      //只能输入数字
      if (/[^\d]/.test(value)) {
        value = value.replace(/[^\d]/g, "");
      }
      this.Formlist[index].value = value;
      this.changeAll();
    },
    // 范围输入框设置只能输入数字
    ChangeNumberlater(value, index) {
      if (/[^\d]/.test(value)) {
        value = value.replace(/[^\d]/g, "");
      }
      this.Formlist[index].laterVal = value;
      this.changeAll();
    },
    // selectSearch类型下拉框搜素上色
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  }
};
</script>

<style lang="less" scoped>
.form_ui {
  margin-bottom: 30px;
}
.message {
  padding: 10px;
}
.form_title {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  font-weight: bolder;
  border-left: 3px solid #16828b;
}
.inputIcon {
  display: flex;
  align-items: center;
}
.icons {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  height: 32px;
  color: #495057;
  border: 1px solid #ced4da;
  margin-left: -2px;
  border-left: none;
  background: #e9ecef;
}
/deep/.ant-input-number {
  display: inline-block;
  width: 100%;
}
.flex {
  display: flex;
}
.form_btn_span {
  margin-left: 15px;
  font-size: 12px;
}
.form_btn_span:hover {
  color: #1890ff;
  cursor: pointer;
}
.form_btn svg {
  fill: #1890ff;
}
.inpt_box {
  align-items: center;
  height: 34px;
  border: 1px solid #d9d9d9;
}
.inpt_box input {
  flex: 1;
  border: none;
}
.inpt_box_unit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 32px;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
  background-color: #e9ecef;
}

.box:nth-child(4n+1){
  margin-left: 0px;
}
.box{
  margin-left: 20px;border: 1px solid #d9d9d9;
  margin-top: 10px;
   width: 182px;;
}
.mydiv img {
  // max-width: 201px;
  width: 100%;
  // max-height: 200px;
  height: 100px;
}
.mydiv {
 height: 100%;
  // width: 100%;
 // max-height: 200px;
// text-align: center;
 position: relative;
 z-index: 0;
 padding: 5px;
}
.close:hover{
  color: red;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  padding-top: 3px;
padding-right: 3px;
  font-size: 18px;
  color: rgba(5, 108, 181, 0.65);
}

/deep/.ant-tag {
    color: #16828b !important;
    background: #ffffff !important;
    border-color: #16828b !important;
}
</style>